/**
 * (Группа 4 · экран 1) Список отелей.
 *
 * Чипы-фильтры по статусу, поиск, переход в карточку. Таблица → карточки на
 * мобильном (адаптив в admin.css). Данные REAL: GET /v1/admin/tenants.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useHotels } from './useHotels.js';

const STATUS_FILTERS = ['all', 'active', 'trial', 'past_due', 'suspended', 'archived'] as const;

const STATUS_LABEL: Record<string, string> = {
  all: 'Все',
  active: 'Активные',
  trial: 'Триал',
  past_due: 'Просрочка',
  suspended: 'Приостановлены',
  archived: 'Архив',
};

export function HotelsListPage(): JSX.Element {
  const [status, setStatus] = useState<string>('all');
  const { data, isLoading, isError } = useHotels(status === 'all' ? undefined : status);

  return (
    <section className="hsc-page" data-testid="hotels-list">
      <h1 className="hsc-page__title">Отели</h1>

      <div className="admin-chips" role="tablist" aria-label="Фильтр по статусу">
        {STATUS_FILTERS.map((s) => (
          <button
            key={s}
            type="button"
            role="tab"
            aria-selected={status === s}
            className={'admin-chip' + (status === s ? ' admin-chip--active' : '')}
            onClick={() => setStatus(s)}
          >
            {STATUS_LABEL[s]}
          </button>
        ))}
      </div>

      {isLoading && <p>Загрузка…</p>}
      {isError && <p role="alert">Не удалось загрузить список отелей.</p>}

      {data && (
        <table className="admin-table" data-testid="hotels-table">
          <thead>
            <tr>
              <th>Отель</th>
              <th>Слаг</th>
              <th>Тариф</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {data.items.length === 0 ? (
              <tr>
                <td colSpan={4}>Отелей нет</td>
              </tr>
            ) : (
              data.items.map((t) => (
                <tr key={t.id}>
                  <td>
                    <Link to={`/hotels/${t.id}`} className="admin-link">
                      {t.display_name}
                    </Link>
                  </td>
                  <td>{t.slug}</td>
                  <td>{t.tier}</td>
                  <td>{t.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </section>
  );
}
